"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadUpdatePayloadSchema = exports.ThreadCreatePayloadSchema = exports.ThreadQuerySchema = exports.ThreadListSchema = exports.ThreadObjectSchema = exports.ThreadInputEmailSchema = exports.ThreadInputSchema = exports.ThreadStatusSchema = void 0;
const zod_1 = require("zod");
const list_1 = require("../list");
const workflow_1 = require("../workflow");
const workspace_1 = require("../workflow/workspace");
// Common
exports.ThreadStatusSchema = zod_1.z.enum(['open', 'closed']).openapi('ThreadStatus');
exports.ThreadInputSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).openapi('ThreadInput');
exports.ThreadInputEmailSchema = zod_1.z
    .string({ description: 'Email address of the user' })
    .email();
// Object
exports.ThreadObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('thread'),
    status: exports.ThreadStatusSchema,
    title: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    workflow: workflow_1.WorkflowTypeSchema,
    input: exports.ThreadInputSchema,
    created_at: zod_1.z.date().openapi({ format: 'date-time' }),
})
    .openapi('ThreadObject');
exports.ThreadListSchema = (0, list_1.ListResponseSchema)(exports.ThreadObjectSchema, {
    title: 'ThreadList',
});
// Query
exports.ThreadQuerySchema = zod_1.z
    .object({
    status: exports.ThreadStatusSchema.optional(),
    workflow: workflow_1.WorkflowTypeSchema.optional(),
    limit: zod_1.z.number({ coerce: true }).optional(),
})
    .openapi('ThreadQuery');
// Create
exports.ThreadCreatePayloadSchema = zod_1.z
    .discriminatedUnion('type', [
    // z
    //     .object({
    //         type: z.literal('task'),
    //         title: z.string().optional(),
    //         description: z.string().optional(),
    //         data: WorkflowTaskInputSchema,
    //     })
    //     .openapi('ThreadCreateTaskPayload'),
    zod_1.z
        .object({
        type: zod_1.z.literal('form'),
        title: zod_1.z.string().optional(),
        description: zod_1.z.string().optional(),
        email: exports.ThreadInputEmailSchema.optional(),
        data: workflow_1.WorkflowTaskInputSchema,
        metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    })
        .openapi('ThreadCreateFormPayload'),
    zod_1.z
        .object({
        type: zod_1.z.literal('form_v2'),
        title: zod_1.z.string().optional(),
        description: zod_1.z.string().optional(),
        email: exports.ThreadInputEmailSchema.optional(),
        data: workflow_1.WorkflowFormInputSchema,
        metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    })
        .openapi('ThreadCreateFormV2Payload'),
    zod_1.z
        .object({
        type: zod_1.z.literal('workspace'),
        title: zod_1.z.string().optional(),
        description: zod_1.z.string().optional(),
        email: exports.ThreadInputEmailSchema.optional(),
        metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
        data: workspace_1.WorkflowWorkspaceFormInputSchema,
    })
        .openapi('ThreadCreateWorkspacePayload'),
])
    .openapi('ThreadCreatePayload');
// Update
exports.ThreadUpdatePayloadSchema = zod_1.z
    .object({
    status: exports.ThreadStatusSchema.optional(),
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
})
    .openapi('ThreadUpdatePayload');
//# sourceMappingURL=threadSchema.js.map